import { getSliderValueFromRawValue } from '../scenes/poker/pixiComponents/slider/sliderUtils';
function getRawSetBetActions({ betSliderMaxAmount, betTotalAmountToCall, myNumChipsThisPhase, myTotalBetAmount, totalPotSize }) {
    function getSetBetRelativeMode() {
        if (myTotalBetAmount === myNumChipsThisPhase) {
            // preflop, always use multiplier mode
            return 'multiplier';
        }
        if (myTotalBetAmount === betTotalAmountToCall) {
            return 'pot-ratio';
        }
        return 'multiplier';
    }
    const setBetRelativeMode = getSetBetRelativeMode();
    const maxBetAction = {
        setBetActionType: 'max',
        betSliderAmount: betSliderMaxAmount
    };
    switch (setBetRelativeMode) {
        case 'multiplier': {
            const highestBetThisPhase = betTotalAmountToCall - myTotalBetAmount + myNumChipsThisPhase;
            return [
                {
                    setBetActionType: '2x',
                    betSliderAmount: highestBetThisPhase * 2 - myNumChipsThisPhase
                },
                {
                    setBetActionType: '3x',
                    betSliderAmount: highestBetThisPhase * 3 - myNumChipsThisPhase
                },
                {
                    setBetActionType: '5x',
                    betSliderAmount: highestBetThisPhase * 5 - myNumChipsThisPhase
                },
                maxBetAction
            ];
        }
        case 'pot-ratio': {
            return [
                {
                    setBetActionType: 'quarter-pot',
                    betSliderAmount: totalPotSize / 4
                },
                {
                    setBetActionType: 'half-pot',
                    betSliderAmount: totalPotSize / 2
                },
                {
                    setBetActionType: 'three-quarter-pot',
                    betSliderAmount: (3 * totalPotSize) / 4
                },
                {
                    setBetActionType: 'pot',
                    betSliderAmount: totalPotSize
                },
                maxBetAction
            ];
        }
    }
}
export function getSetBetActionsFromMyTurnProperties(myTurnProperties, totalPotSize) {
    const { betIncrement, betSliderMinAmount, betSliderMaxAmount, betTotalAmountToCall, myNumChipsThisPhase, myTotalBetAmount } = myTurnProperties;
    const getSetBetActionsObj = {
        betIncrement,
        betSliderMinAmount,
        betSliderMaxAmount,
        betTotalAmountToCall,
        myNumChipsThisPhase,
        myTotalBetAmount,
        totalPotSize
    };
    return getSetBetActions(getSetBetActionsObj);
}
export function getSetBetActions({ betIncrement, betSliderMinAmount, betSliderMaxAmount, betTotalAmountToCall, myNumChipsThisPhase, myTotalBetAmount, totalPotSize }) {
    const rawSetBetActions = getRawSetBetActions({
        betSliderMaxAmount,
        betTotalAmountToCall,
        myNumChipsThisPhase,
        myTotalBetAmount,
        totalPotSize
    }).map((rawSetBetAction) => ({
        ...rawSetBetAction,
        betSliderAmount: getSliderValueFromRawValue(rawSetBetAction.betSliderAmount, betSliderMinAmount, betSliderMaxAmount, betIncrement)
    }));
    const setBetActions = [];
    for (let i = rawSetBetActions.length - 1; i >= 0; i--) {
        const currRawSetBetAction = rawSetBetActions[i];
        if (i === rawSetBetActions.length - 1 ||
            currRawSetBetAction.betSliderAmount < rawSetBetActions[i + 1].betSliderAmount) {
            if (currRawSetBetAction.betSliderAmount < betSliderMinAmount ||
                currRawSetBetAction.betSliderAmount > betSliderMaxAmount) {
                setBetActions.unshift(undefined);
            }
            else {
                setBetActions.unshift(currRawSetBetAction);
            }
        }
        else {
            setBetActions.unshift(undefined);
        }
    }
    return setBetActions;
}
